import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import Loader from '../../elements/Loader';
import LocationDetailsForm from '../../molecules/EditLocations/LocationDetailsForm';
import LocationSettingsForm from '../../molecules/EditLocations/LocationSettingsForm';
import TaxesForm from '../../molecules/EditLocations/TaxesForm';
import { TabSelector } from '../TabSelector';
import api from '../../../lib/api';
import { Currency, LocationDetails } from '../../../types/location';
import PageNotFound from '../PageNotFound';
import withAuth from '../../../wrappers/auth';
import EditLocationProvider from '../../../context/EditLocationContext';

const EditLocation = () => {
  const { id } = useParams<{ id: string }>();

  const {
    data: locationData,
    isLoading,
    isRefetching,
  } = useQuery<LocationDetails, string>({
    queryKey: ['get_location_by_id', id],
    queryFn: () =>
      api.fetch(`get_location_by_id`, { id: id }) as unknown as LocationDetails,
    retry: 0,
  });

  const [currency, setCurrency] = useState<Currency | null>(null);

  const locationDataResponse = useMemo(() => {
    const response = locationData?.data as unknown as LocationDetails;

    setCurrency(
      response?.data?.attributes?.currency_code as unknown as Currency,
    );

    return response;
  }, [locationData]);

  // const activeLayoutsIds = locationDataResponse?.classrooms?.included.map(
  //   (el) => (el.attributes.listed === true ? el.id : null),
  // );

  // const classroomData: ClassroomTransformedResponse[] =
  //   locationDataResponse?.classrooms?.data.map((el) => {
  //     const activeLayouts = el.relationships.layouts.data.filter((el) =>
  //       activeLayoutsIds.includes(el.id),
  //     );

  //     return {
  //       id: el.id,
  //       name: el.attributes.name,
  //       listed: el.attributes.listed,
  //       activeLayouts: activeLayouts.length,
  //     };
  //   });

  // const activeClassroomData = classroomData?.filter(
  //   (classroom) => classroom.listed === true,
  // );

  // const inactiveClassroomData = classroomData?.filter(
  //   (classroom) => classroom.listed === false,
  // );

  return (
    <div className='w-full h-screen overflow-y-auto bg-gray-lighter'>
      {isLoading || isRefetching ? (
        <div className='flex justify-center items-center w-full h-[100svh]'>
          <Loader fillColor='#5F36EB' size='48' />
        </div>
      ) : locationDataResponse && locationDataResponse !== undefined && id ? (
        <div className='p-8'>
          <h1 className='text-dark-header font-bold text-[32px] m-0 p-0 leading-8'>
            {locationDataResponse?.data?.attributes?.name}
          </h1>
          <EditLocationProvider
            value={{
              currency,
              setCurrency,
            }}
          >
            <TabSelector
              tabHeaders={[
                { title: 'Location Details' },
                { title: 'Location Settings' },
                // { title: 'Classrooms', count: activeClassroomData?.length },
                { title: 'Taxes' },
              ]}
            >
              <LocationDetailsForm
                id={id}
                locationDataResponse={locationDataResponse}
              />
              <LocationSettingsForm
                id={id}
                locationDataResponse={locationDataResponse}
              />

              {/* <ClassroomsForm
                activeClassroomData={activeClassroomData}
                inactiveClassroomData={inactiveClassroomData}
              /> */}

              <TaxesForm
                partnerId={
                  locationDataResponse?.data?.relationships?.partner?.data?.id
                }
              />
            </TabSelector>
          </EditLocationProvider>
        </div>
      ) : (
        <PageNotFound />
      )}
    </div>
  );
};

export default withAuth(EditLocation);
